import * as React from 'react';
import { SVGProps } from 'react';

const IconBookSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 3a1 1 0 0 1 1-1v7l1.5-1L7 9V2h5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 1 0 0 2h8a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V3Z" />
  </svg>
);
export default IconBookSizeS;
